<template>
    <tr>
        <td class="link" @click="goToLotSinglePage">
            {{ favorite.user.name }}
        </td>
        <td class="link" @click="goToLotSinglePage">
            {{ favorite.created_at.split(' ')[0] }}<br>
            {{ favorite.created_at.split(' ')[1] }}<br>
        </td>
        <td class="link" @click="goToLotSinglePage">
            {{ favorite.lot ? favorite.lot.lot_date.split(' ')[0] : favorite.one_price_list.auct_date.split(' ')[0] }}<br>
            {{ favorite.lot ? favorite.lot.lot_date.split(' ')[1] : favorite.one_price_list.auct_date.split(' ')[1] }}
        </td>
        <td class="picture-td">
            <figure class="image is-65x65" @click="openGallery">
                <img :src="(favorite.lot ? favorite.lot.pictures.split('#')[1] : favorite.one_price_list.images) + '&w=320'">
            </figure>
        </td>

        <td class="link" @click="goToLotSinglePage">
            {{ favorite.lot ? favorite.lot.auction_name : favorite.one_price_list.auct_name }}<br>
            {{ favorite.lot ? favorite.lot.bid : favorite.one_price_list.lot_num }}<br>
        </td>
        <td class="link">
            <button class="button is-outlined" :class="isTranslated(favorite)" @click="openTranslateModal()">T</button>
            <translate-favorite-modal v-if="favorite.lot" :lot="favorite.lot" :lot_id="favorite.lot_id"></translate-favorite-modal>
            <translate-favorite-modal v-else :lot="favorite.one_price_list" :lot_id="favorite.lot_id"></translate-favorite-modal>
        </td>
        <td class="link" @click="goToLotSinglePage">
            {{ favorite.lot ? '' : favorite.counter_offer | formatNumber }}
        </td>
        <td @click="goToLotSinglePage">
            {{ (favorite.lot ? (favorite.lot.start_price * 1000) :favorite.one_price_list.price_start) | formatNumber }}<br>
            {{ timeSince(new Date(favorite.lot ? favorite.lot.lot_date : favorite.one_price_list.auct_date)) }}
        </td>
        <td @click="goToLotSinglePage">
            {{ (favorite.lot ? (favorite.lot.result) : '') }}<br>
            <span class="result_price">{{(favorite.lot ? favorite.lot.end_price * 1000 : '') | formatNumber }}</span>
        </td>
        <td @click="goToLotSinglePage">
            {{ favorite.lot ? favorite.lot.company : favorite.one_price_list.manuf_name }}

        </td>
        <td @click="goToLotSinglePage">
            {{ favorite.lot ? favorite.lot.model_name_en : favorite.one_price_list.model_name}}
        </td>
        <td @click="goToLotSinglePage">
            {{ favorite.lot ? favorite.lot.model_type_en : favorite.one_price_list.body }}
        </td>
        <td @click="goToLotSinglePage">
            {{ (favorite.lot ? (favorite.lot.mileage_num * 1000) : favorite.one_price_list.mileage ) | formatNumber }} km<br>
        </td>


        <td @click="goToLotSinglePage">
            {{ favorite.lot ? favorite.lot.model_year_en : favorite.one_price_list.year }}
        </td>
        <td @click="goToLotSinglePage">
            {{ favorite.lot ? favorite.lot.displacement_num : 0 }} cc
        </td>
        <td @click="goToLotSinglePage">
            {{ favorite.lot ? favorite.lot.transmission_en : favorite.one_price_list.transmission }}
        </td>
        <td @click="goToLotSinglePage">
            {{ favorite.lot ? favorite.lot.scores : favorite.one_price_list.rate }}
        </td>
        <td>
            <div class="field">
                <a v-if="isOwner" class="button is-warning  is-small"
                   v-bind:class="{ 'is-loading': isLoading }"
                   @click.prevent="deleteFromFavorites()">
                    <span><i class="fas fa-ban"></i></span>
                </a>
            </div>
        </td>
        <td>
            {{ favorite.lot ? 'Auction' : 'Buy Now'}}
        </td>
        <td v-if="isOwner">
            <a class="button is-theme-primary is-fullwidth" v-if="isAdmin" @click="openSingleCarTransferModal">TRANSFER CAR</a>
        </td>
        <td v-else>

        </td>
        <transfer-favorite-modal v-if="isAdmin && isOwner" :car="favorite"></transfer-favorite-modal>
    </tr>
</template>

<script>
    import favoriteDelete from './../Card/Buttons/Lots/FavoriteDelete.vue'
    import apiFavorites from '../../api/apiFavorites'
    import TransferFavoriteModal from "./TransferFavoriteModal";
    import TranslateFavoriteModal from "./TranslateFavoriteModal";
    export default {
        props: ['favorite'],
        components: {
            TranslateFavoriteModal,
            TransferFavoriteModal,
            favoriteDelete
        },
        data() {
            return {
                isLoading: false,
                currentFavorite: {
                    lot_id: this.favorite.lot_id
                }
            }
        },
        methods: {
            goToLotSinglePage() {
                let singlePage = this.favorite.lot ? '/single/' : '/buy-now/';

                    this.$router.push({
                        path: singlePage + this.favorite.lot_id,
                    })
            },
            openGallery() {
                this.$store.dispatch('setResultGalleryItems', this.favorite.lot ? this.favorite.lot.pictures.split('#') : [this.favorite.one_price_list.images, this.favorite.one_price_list.auction_list])
                this.$store.dispatch('setResultGalleryStatus', true)
            },
            removeRow() {
                this.$destroy();
            },
            deleteFromFavorites() {
                this.isLoading = true
                apiFavorites
                    .deleteFavoritesRequest(this.currentFavorite)
                    .then((response) => {
                        this.isLoading = false
                        this.$el.parentNode.removeChild(this.$el);
                    })
                    .catch((err) => {
                        console.log(err)
                        this.isLoading = false
                    })
            },
            openSingleCarTransferModal(){
                this.$store.dispatch('setFavoriteCarTransferModalStatus', { status: true, bidId: this.favorite.lot_id })
            },
            openTranslateModal() {
                this.$store.dispatch('changeTranslateModalStatus', { status: true, bidId: this.favorite.lot_id })
            },
            isTranslated(favorite) {
                let lot = favorite.lot ? favorite.lot : favorite.one_price_list;
                if (typeof lot !== 'undefined' && lot !== null) {
                    if (lot.translation !== null) {
                        return 'is-primary'
                    } else {
                        return 'is-danger'
                    }
                }else {
                    return 'is-danger'
                }
            },
            timeSince(date){
                var seconds = Math.floor((new Date() - date) / 1000);

                var interval = Math.floor(seconds / 31536000);

                if (interval > 1) {
                    return interval + " years ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " years";
                }
                interval = Math.floor(seconds / 2592000);
                if (interval > 1) {
                    return interval + " months ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " months";
                }
                interval = Math.floor(seconds / 86400);
                if (interval > 1) {
                    return interval + " days ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " days";
                }
                interval = Math.floor(seconds / 3600);
                if (interval > 1) {
                    return interval + " hours ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " hours";
                }
                interval = Math.floor(seconds / 60);
                if (interval > 1) {
                    return interval + " minutes ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " minutes";
                }
                return Math.floor(seconds) + " seconds";
            }

        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isOwner () {
                if (this.favorite.owner_id == this.favorite.user_id) {
                    return true
                }
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 12px;
    }
    .picture-td {
        width: 65px;
    }
    .link {
        cursor: pointer;
    }
    .image {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Favorites/FavoritesTableRow.vue